const e=(i,t)=>!i.sortHint&&!t.sortHint||!t.sortHint?-1:i.sortHint?i.sortHint.localeCompare(t.sortHint):1;export{e as viewSortHintComparer};
